import i18next from 'i18next';
import React from 'react';
import Strong from '~/components/Strong';

const monthOrYear = (selectedPeriod, record) => {
  const meses = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ];

  const monthText = record.month ? meses[record.month - 1] : record.year;

  return selectedPeriod === 'month' ? (record.month ? `${monthText} / ${record.year}` : 'TOTAL') : record.year;
};

export const financialBalanceSheetsColumns = (selectedPeriod, isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => {
          return (
            <div>
              <Strong>{i18next.t('Período')}:</Strong> {monthOrYear(selectedPeriod, record)}
              <br />
              <Strong>{i18next.t('Receitas')}:</Strong>{' '}
              {Number(record.revenues).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              <br />
              <Strong>{i18next.t('Despesas')}:</Strong>{' '}
              {Number(record.expenses).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              <br />
              <Strong>{i18next.t('Lucratividade')}:</Strong>{' '}
              {Number(record.profitability).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              <br />
              <Strong>{i18next.t('Receitas extras')}:</Strong>{' '}
              {Number(record.extra_revenues).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              <br />
              <Strong>{i18next.t('Despesas extras')}:</Strong>{' '}
              {Number(record.extra_expenses).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              <br />
              <Strong>{i18next.t('Patrimônios')}:</Strong>{' '}
              {Number(record.investments).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              <br />
              <Strong>{i18next.t('Saldo')}:</Strong>{' '}
              {Number(record.balance).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </div>
          );
        },
      },
    ];
  }

  return [
    {
      title: i18next.t('Período'),
      dataIndex: 'month',
      key: 'period',
      width: '200px',
      render: (_, record) => monthOrYear(selectedPeriod, record),
    },
    {
      title: i18next.t('Receitas'),
      dataIndex: 'revenues',
      key: 'revenues',
      width: '300px',
      render: (_, record) => Number(record.revenues).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), // converte para R$
    },
    {
      title: i18next.t('Despesas'),
      dataIndex: 'expenses',
      key: 'expenses',
      width: '300px',
      render: (_, record) => Number(record.expenses).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), // converte para R$
    },
    {
      title: i18next.t('Lucratividade'),
      dataIndex: 'profitability',
      key: 'profitability',
      width: '300px',
      render: (_, record) =>
        Number(record.profitability).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), // converte para R$
    },
    {
      title: i18next.t('Receitas extras'),
      dataIndex: 'extra_revenues',
      key: 'extra_revenues',
      width: '300px',
      render: (_, record) =>
        Number(record.extra_revenues).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), // converte para R$
    },
    {
      title: i18next.t('Despesas extras'),
      dataIndex: 'extra_expenses',
      key: 'extra_expenses',
      width: '300px',
      render: (_, record) =>
        Number(record.extra_expenses).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), // converte para R$
    },
    {
      title: i18next.t('Patrimônios'),
      dataIndex: 'investments',
      key: 'investments',
      width: '300px',
      render: (_, record) => Number(record.investments).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), // converte para R$
    },
    {
      title: i18next.t('Saldo'),
      dataIndex: 'balance',
      key: 'balance',
      width: '300px',
      render: (_, record) => Number(record.balance).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), // converte para R$
    },
  ];
};
